import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/colors.css';
import App from './App';

// Suprimir erro inofensivo do ResizeObserver (bug do browser com React Flow)
const resizeObserverErr = window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);